<template>
    <RegistrationStepPage step-name="participants">
        <ParticipantsListing />
    </RegistrationStepPage>
</template>

<script>
import ParticipantsListing from "@/components/pages/registration/ParticipantsListing";
import registrationPersonsMixin from "@/mixins/registration/registrationPersonsMixin";
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import RegistrationStepPage from '@/components/farbcode-core/Registration/RegistrationStepPage'

export default {
    name: "Participants",
    components: {RegistrationStepPage, ParticipantsListing},
    mixins: [mainRegistrationMixin, registrationPersonsMixin],
    watch: {
        eventIsLoaded: {
            handler(eventIsLoaded) {
                if (eventIsLoaded && this.participatingPersons.length === 0) {
                    this.addParticipant()
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>


</style>
